import { VillaSpacesPropertiesTypes } from "@website/accommodation-ui/villa-spaces/villa-spaces.types";
import { MaterialIcon } from "@website/icons/material";
import { Tooltip } from "@website/ui/tooltip";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = ({ spaces }: VillaSpacesPropertiesTypes) => {
  const router = useRouter();
  if (
    !spaces?.length ||
    !spaces?.some((item) => item?.amenitiesGroup?.length > 0)
  )
    return null;

  return (
    <div className="flex flex-col gap-4" id="hotel_spaces">
      <div className="text-subtitle-1 md:text-headline-6">فضاهای اقامتگاه</div>
      <div className="flex flex-col gap-4">
        {spaces?.map(({ title, amenitiesGroup }) =>
          amenitiesGroup?.length > 0 ? (
            <div className="flex flex-col gap-4">
              <div className="text-subtitle-1">{title}</div>
              <div className="grid gap-4 md:grid-cols-2">
                {amenitiesGroup?.map(({ title, items }) => (
                  <div className="border-outline-thin flex h-[72px] w-full flex-col gap-4 rounded-lg border p-2">
                    <div className="flex flex-col gap-2">
                      <span className="text-caption text-on-surface-medium-emphasis">
                        {title}
                      </span>
                      <Tooltip
                        className="!h-max !w-full md:z-50"
                        placement="top"
                        title={numberConvert(
                          items?.map(({ title }) => title)?.join("، "),
                          {
                            locale: router?.locale
                          }
                        )}
                        titleClassName={`${
                          numberConvert(
                            items?.map(({ title }) => title)?.join("، "),
                            {
                              locale: router?.locale
                            }
                          ).length < 35 && "hidden"
                        }`}
                      >
                        <div className="flex flex-row items-center justify-between gap-1 text-justify">
                          <div className="text-body-1 truncate">
                            {numberConvert(
                              items?.map(({ title }) => title)?.join("\n "),
                              {
                                locale: router?.locale
                              }
                            )?.length < 35 ? (
                              <span>
                                {numberConvert(
                                  items?.map(({ title }) => title)?.join("\n "),
                                  {
                                    locale: router?.locale
                                  }
                                )}
                              </span>
                            ) : (
                              <div>
                                <span>
                                  {numberConvert(
                                    items
                                      ?.map(({ title }) => title)
                                      ?.join("، "),
                                    {
                                      locale: router?.locale
                                    }
                                  )?.slice(0, 33)}
                                </span>
                                <span className="text-secondary text-caption cursor-pointer">
                                  ...بیشتر
                                </span>
                              </div>
                            )}
                          </div>
                          {items?.some(({ description }) => description) && (
                            <Tooltip
                              className="!h-max"
                              placement="bottom"
                              title={numberConvert(
                                items
                                  ?.map(({ description }) => description)
                                  ?.join("، "),
                                {
                                  locale: router?.locale
                                }
                              )}
                              titleClassName={`!left-0 ${
                                !items?.every(
                                  ({ description }) => description
                                ) && "hidden"
                              }`}
                            >
                              <MaterialIcon
                                className="text-headline-6 size-[24px] cursor-pointer"
                                name="info"
                                variant="outlined"
                              />
                            </Tooltip>
                          )}
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};
export const VillaSpaces = memo(Component, deepCompare);
